// import { Outlet, Link } from 'react-router-dom';
// import { useAuth } from '../contexts/AuthContext';

// export const PublicLayout = () => {
//   const { role, signOut } = useAuth();

//   return (
//     <div className="min-h-screen bg-gray-50">
//       <header className="bg-white shadow-sm">
//         <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4">
//           <Link to="/" className="text-xl font-bold text-blue-700">
//             📞 Tandulwadi Phone Book
//           </Link>
//           <nav className="flex items-center gap-4">
//             <Link to="/phone-book" className="text-sm font-medium text-gray-700 hover:text-blue-700">
//               Phone Book
//             </Link>
//             {role === 'ADMIN' && (
//               <Link to="/admin" className="text-sm font-medium text-gray-700 hover:text-blue-700">
//                 Admin
//               </Link>
//             )}
//             {(role === 'EMPLOYEE' || role === 'ADMIN') && (
//               <Link to="/employee" className="text-sm font-medium text-gray-700 hover:text-blue-700">
//                 Employee
//               </Link>
//             )}
//             {role ? (
//               <button
//                 onClick={() => signOut()}
//                 className="rounded bg-gray-200 px-3 py-1.5 text-sm font-medium text-gray-800 hover:bg-gray-300"
//               >
//                 Logout
//               </button>
//             ) : (
//               <>
//                 <Link
//                   to="/login"
//                   className="rounded bg-blue-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-blue-700"
//                 >
//                   Login
//                 </Link>
//                 <Link
//                   to="/signup"
//                   className="rounded bg-gray-200 px-3 py-1.5 text-sm font-medium text-gray-800 hover:bg-gray-300"
//                 >
//                   Sign Up
//                 </Link>
//               </>
//             )}
//           </nav>
//         </div>
//       </header>
//       <main className="mx-auto max-w-7xl px-4 py-6">
//         <Outlet />
//       </main>
//     </div>
//   );
// };
import { Outlet, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FlipWords } from '../components/velora/flip-words';

export const PublicLayout = () => {
  const { role, signOut } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="mx-auto flex max-w-7xl flex-col items-center gap-3 px-4 py-4 md:flex-row md:justify-between md:gap-0">
          
          {/* Logo + Application Name */}
          <Link
            to="/"
            className="flex items-center gap-3 text-xl font-bold text-blue-700"
          >
            <img
              src="/static/logo.png"
              alt="Tandulwadi Phone Book"
              className="h-10 w-10 object-contain"
            />

            <span className="text-center text-lg md:text-xl leading-tight">
              <FlipWords
                words={['Tandulwadi', 'तांदुळवाडी']}
                duration={5000}
              />{' '}
              Phone Book
            </span>
          </Link>

          {/* Navigation */}
          <nav className="flex flex-wrap items-center justify-center gap-2 md:gap-4">
            <Link
              to="/phone-book"
              className="hidden text-sm font-medium text-gray-700 hover:text-blue-700 md:inline"
            >
              Phone Book
            </Link>

            {role === 'ADMIN' && (
              <Link
                to="/admin"
                className="text-sm font-medium text-gray-700 hover:text-blue-700"
              >
                Admin
              </Link>
            )}

            {(role === 'EMPLOYEE' || role === 'ADMIN') && (
              <Link
                to="/employee"
                className="text-sm font-medium text-gray-700 hover:text-blue-700"
              >
                Dashboard
              </Link>
            )}

            {role ? (
              <button
                onClick={() => signOut()}
                className="rounded bg-gray-200 px-3 py-1.5 text-sm font-medium text-gray-800 hover:bg-gray-300"
              >
                Logout
              </button>
            ) : (
              <>
                <Link
                  to="/login"
                  className="rounded bg-blue-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-blue-700"
                >
                  Login
                </Link>

                <Link
                  to="/signup"
                  className="rounded bg-gray-200 px-3 py-1.5 text-sm font-medium text-gray-800 hover:bg-gray-300"
                >
                  Sign Up
                </Link>
              </>
            )}
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
};